import React from 'react';
import { motion } from 'framer-motion';

const AboutSection = () => {
  return (
    <section id="about" className="py-16 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4">About NY Concept</h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Your creative partner in visual storytelling
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <h3 className="text-2xl font-bold mb-4">Our Story</h3>
            <p className="text-gray-700 leading-relaxed">
              NY Concept is a premier multimedia company based in Tema, Ghana, specializing in graphic design, photography, and videography. We combine creativity with technical expertise to deliver exceptional visual content that helps businesses and individuals stand out in today's digital landscape.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Our team of passionate professionals is dedicated to transforming your ideas into compelling visual stories that resonate with your audience and achieve your goals.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <h3 className="text-2xl font-bold mb-4">Why Choose Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <span className="w-2 h-2 bg-black rounded-full mt-2 mr-3"></span>
                <span className="text-gray-700">Professional expertise in multiple creative disciplines</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-black rounded-full mt-2 mr-3"></span>
                <span className="text-gray-700">Customized solutions tailored to your needs</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-black rounded-full mt-2 mr-3"></span>
                <span className="text-gray-700">High-quality deliverables that exceed expectations</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-black rounded-full mt-2 mr-3"></span>
                <span className="text-gray-700">Timely delivery and excellent communication</span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection; 